var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1001",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1002"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1008"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 302.063 302.063",
    viewBox: "0 0 302.063 302.063",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.228 50.942c-3.627-5.713-11.727-6.427-16.512-1.647-.054.048-.102.102-.156.156-3.508 3.503-4.147 8.954-1.497 13.143 9.592 15.166 14.329 32.955 13.251 51.603-1.352 23.369-12.779 45.037-30.069 60.819-14.211 12.966-23.32 30.268-25.89 48.738H117.18c-2.511-19.383-11.77-37.472-26.689-51.785-7.741-7.425-14.603-15.847-18.878-25.681C44.923 84.916 88.731 24.36 146.852 21.666c15.128-.676 29.753 2.446 42.864 8.943 4.013 1.99 8.857 1.057 12.028-2.108l.156-.156c5.247-5.236 3.621-13.964-3.02-17.247-16.234-8.02-34.313-11.883-53.019-10.965C83.516 3.024 34.386 59.278 43.04 123.649c3.305 24.586 15.563 47.156 33.24 64.569 12.918 12.725 20.026 29.12 20.037 46.27.005 5.96 4.415 10.826 10.375 10.826h79.156c12.387 0 17.349-4.614 17.312-10.434-.102-16.765 7.285-32.998 20.236-44.495 23.272-20.665 36.619-50.326 36.619-81.382C260.02 88.044 254.14 68.13 243.228 50.942zM191.341 251.581h-85.036c-5.955 0-10.778 4.828-10.778 10.778 0 5.949 4.823 10.778 10.778 10.778h85.036c5.955 0 10.778-4.828 10.778-10.778S197.296 251.581 191.341 251.581zM175.66 280.507h-53.674c-5.955 0-10.778 4.828-10.778 10.778 0 5.949 4.823 10.778 10.778 10.778h53.668c5.955 0 10.778-4.828 10.778-10.778S181.615 280.507 175.66 280.507z",
    fill: "#03507d",
    className: "color000 svgShape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.eddff032821ba13d1b73c7786f218109.svg";
export { ForwardRef as ReactComponent };